import { auditReports } from '@mi-front/api-clients';
import { Report } from '@mi-front/core';
import { FormattedMessage } from 'react-intl';
import { JobProgress } from '../../../../../components/base/JobProgress';

interface Props {
  report: Report;
}

export function ReportListStatus({ report }: Props) {
  // Check if this is a GIP or GIP Alternative report
  const isGipReport = report.type === auditReports.GipReportDtoTypeEnum.AUDIT_GIP_STATUS;
  const isGipAltReport =
    report.type === auditReports.GipAltReportDtoTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT;

  if (isGipReport || isGipAltReport) {
    const r = report as unknown as auditReports.GipReportDto | auditReports.GipAltReportDto;
    const export_ = r.data.export;

    // No export configured
    if (!export_) {
      return (
        <FormattedMessage id="audit.reportsList.noExport" defaultMessage="No exportado">
          {(txt) => <span className="text-muted">{txt}</span>}
        </FormattedMessage>
      );
    }

    // Export in progress or completed - use JobProgress for modern status display
    if (export_.status) {
      return (
        <JobProgress
          job={
            {
              status: export_.status,
            } as any
          }
          size="small"
        />
      );
    }

    // Export configured but no status yet
    return (
      <FormattedMessage id="audit.reportsList.noExport" defaultMessage="No exportado">
        {(txt) => <span className="text-muted">{txt}</span>}
      </FormattedMessage>
    );
  }

  return null;
}
